// using a function to create the getters for each type of request, since they all use the same getters with different file name

import moment from 'moment';

const createGetters = (file) => {
   return {
      getActive(state) {
         return state.active;
      },
      getRequests(state) {
         return state.requests;
      },
      getLastRequest(state) {
         if (state.requests && state.requests.length > 0) {
            return state.requests.filter(request => {
               return request.status !== "finished";
            })
               .sort((a, b) => {
                  if (a.createdAt > b.createdAt) {
                     return -1;
                  } else if (a.createdAt < b.createdAt) {
                     return 1;
                  } else {
                     return 0
                  }
               })[0];
         } else {
            return null
         }
      },
      getFilteredRequests(state) {
         if (state.requests.length > 0) {
            return state.requests
               .filter(request => {
                  if (state.filters.name) {
                     return request.name.toUpperCase().search(state.filters.name.toUpperCase()) >= 0;
                  } else {
                     return true;
                  }
               })
               .filter(request => {
                  if (state.filters.status && state.filters.status !== "all") {
                     return request.status === state.filters.status;
                  } else {
                     return true;
                  }
               })
               .filter(request => {
                  if (state.filters.incompleteServices && state.filters.incompleteServices !== "any") {
                     const serviceFound = request.services.filter(service => {
                        return service.name === state.filters.incompleteServices && !service.is_complete;
                     });
                     return serviceFound.length > 0 ? true : false;
                  } else {
                     return true;
                  }
               })
               .filter(request => {
                  if (state.filters.dateMin) {
                     return moment(request.createdAt).format("MM-DD-YYYY hh:mm:ss a") >= moment(state.filters.dateMin, ["MM-DD-YYYY hh:mm:ss a"]).format("MM-DD-YYYY hh:mm:ss a");
                  } else {
                     return true;
                  }
               })
               .filter(request => {
                  if (state.filters.dateMax) {
                     return moment(request.createdAt).format("MM-DD-YYYY hh:mm:ss a") <= moment(state.filters.dateMax, ["MM-DD-YYYY hh:mm:ss a"]).format("MM-DD-YYYY hh:mm:ss a");
                  } else {
                     return true;
                  }
               })
               .sort((a, b) => {
                  if (state.filters.sort === "newest-to-oldest") {
                     if (a.createdAt > b.createdAt) {
                        return -1;
                     } else if (a.createdAt < b.createdAt) {
                        return 1;
                     } else {
                        return 0
                     }
                  } else {
                     if (a.createdAt < b.createdAt) {
                        return -1;
                     } else if (a.createdAt > b.createdAt) {
                        return 1;
                     } else {
                        return 0
                     }
                  }
               });
         } else {
            return []
         }
      },
      getFilters(state) {
         return state.filters;
      },
      getServices(state) {
         return state.uniqueServices;
      },
      getRequestCount(state) {
         if (state.requests) {
            return state.requests.length;
         }
         return 0;
      },
      getUnfinishedCount(state) {
         if (state.requests) {
            return state.requests.reduce((a, b) => {
               return b.status !== "finished" ? a += 1 : a;
            }, 0)
         }
         return 0;
      },
      getUnfinishedRequests(state) {
         return state.requests.filter(request => {
            return request.status !== "finished";
         })
      },
      getRequestStatusCounts(state) {
         let results = [];
         const statuses = state.statuses;
         if (state.requests) {
            statuses.forEach(status => {
               const count = state.requests.reduce((a, b) => {
                  return b.status === status ? a += 1 : a;
               }, 0);
               results.push({
                  id: `${file}__${status}`,
                  name: status,
                  count: count
               });
            });
            return results;
         }
         return [];
      },
      getChartData(state) {
         const statuses = state.statuses;
         if (state.requests) {
            const data = statuses.map(status => {
               return state.requests.reduce((a, b) => {
                  return b.status === status ? a += 1 : a;
               }, 0);
            });
            const chartData = {
               labels: statuses,
               datasets: [
                  {
                     data: data,
                     backgroundColor: [
                        '#4a773c',
                        '#dc6b2f',
                        '#b53522'
                     ]
                  }
               ]
            }
            return chartData;
         }
         return {
            labels: [],
            datasets: [
               { data: [] }
            ]
         }
      }
   }
}

export default createGetters;